// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleShowInCutaway_root__1nY2n","text":"ToggleShowInCutaway_text__2Dipe","active":"ToggleShowInCutaway_active__w5BR1"};